// clearRemoveStreamTokenTimer.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import getOperationData from '../selector/getOperationData.js';

/**
 * Clear remove stream token timer
 * @kind action
 * @param {string} {streamId} - stream id.
 * @return {Promise} Action promise.
 */
const clearRemoveStreamTokenTimer =
  ({ streamId }) =>
  async (dispatch, getState) => {
    const existedTimerId = getOperationData(
      getState(),
      ['timer', 'livestream', streamId, 'removeStreamToken'],
      'timerId'
    );
    if (!existedTimerId || !streamId) {
      return dispatch({ type: '' });
    }
    clearTimeout(existedTimerId);
    dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['timer', 'livestream', streamId, 'removeStreamToken'],
        data: {
          timerId: undefined,
          unixTimestamp: undefined,
        },
      },
    });
  };

export default clearRemoveStreamTokenTimer;
